import React from 'react';
import { Bank } from '../../../../app/models/Bank';
import { BankAccountDataForm, BankAccountType } from '../../../../app/models/BankAccountType';
import LazyLoading from '../../../../components/LazyLoading';

interface SocietyBankAccountFormProps {
    societyBankAccountForm: BankAccountDataForm;
    setSocietyBankAccountForm: (bankAccount: BankAccountDataForm) => void;
    banks: Bank[];
    bankAccountTypes: BankAccountType[];
    errorFields?: Record<string, string[]>;
    fetchingBankAccounts?: boolean
}

const SocietyBankAccountForm = ({
    societyBankAccountForm,
    setSocietyBankAccountForm,
    banks,
    bankAccountTypes,
    errorFields,
    fetchingBankAccounts
}: SocietyBankAccountFormProps) => {

    if (fetchingBankAccounts) {
        return <LazyLoading height={200} />;
    }

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <div className="mb-3">
                        <label htmlFor="bank_id" className="form-label">
                            Banco <span className="text-danger">*</span>
                        </label>
                        <select
                            className={`form-select ${errorFields?.bank_id ? 'is-invalid' : ''}`}
                            id="bank_id"
                            value={societyBankAccountForm?.bank_id || ''}
                            onChange={(e) =>
                                setSocietyBankAccountForm({
                                    ...societyBankAccountForm,
                                    bank_id: parseInt(e.target.value)
                                })
                            }
                        >
                            <option value="">Seleccione un banco</option>
                            {banks.map((bank) => (
                                <option key={bank.id} value={bank.id}>
                                    {bank.name}
                                </option>
                            ))}
                        </select>
                        {errorFields?.bank_id && (
                            <div className="invalid-feedback">{errorFields.bank_id[0]}</div>
                        )}
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="mb-3">
                        <label htmlFor="account_type_id" className="form-label">
                            Tipo de Cuenta <span className="text-danger">*</span>
                        </label>
                        <select
                            className={`form-select ${errorFields?.account_type_id ? 'is-invalid' : ''}`}
                            id="account_type_id"
                            value={societyBankAccountForm?.account_type_id || ''}
                            onChange={(e) =>
                                setSocietyBankAccountForm({
                                    ...societyBankAccountForm,
                                    account_type_id: parseInt(e.target.value)
                                })
                            }
                        >
                            <option value="">Seleccione un tipo de cuenta</option>
                            {bankAccountTypes.map((type) => (
                                <option key={type.id} value={type.id}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                        {errorFields?.account_type_id && (
                            <div className="invalid-feedback">{errorFields.account_type_id[0]}</div>
                        )}
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="mb-3">
                        <label htmlFor="account_number" className="form-label">
                            Número de Cuenta <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            className={`form-control ${errorFields?.account_number ? 'is-invalid' : ''}`}
                            id="account_number"
                            value={societyBankAccountForm?.account_number || ''}
                            onChange={(e) =>
                                setSocietyBankAccountForm({
                                    ...societyBankAccountForm,
                                    account_number: e.target.value
                                })
                            }
                        />
                        {errorFields?.account_number && (
                            <div className="invalid-feedback">{errorFields.account_number[0]}</div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SocietyBankAccountForm;
